<div class="relative size-6 xl:size-10">
  <button
    mat-icon-button
    id="history-btn"
    data-cy="history-trigger"
    [matTooltip]="'store-history.history' | translate"
    [matTooltipPosition]="'below'"
    [attr.aria-expanded]="opened()"
    (click)="onToggle()"
  >
    <mat-icon class="material-icons-outlined">history</mat-icon>
  </button>

  @if (hasDraft()) {
    <span
      class="absolute right-0 top-0 size-2 -translate-x-0.5 -translate-y-0.5 transform rounded-full bg-red-500 text-center text-xs text-white xl:size-4"
      data-cy="history-draft-badge"
    >
    </span>
  }
</div>
